import BaseApi from "./BaseApi";

export default class Expenses extends BaseApi{
    constructor() {
        super();
    }
    

    static async getTypes() {
        return await Expenses.getAxiosInstance().get(Expenses.getFullApiUrl() + "types");
    }

    static async search(params) {
        return await Expenses.getAxiosInstance().get(Expenses.getFullApiUrl(),{params: params});
    }

    static async create(params) {
        return await Expenses.getAxiosInstance().post(Expenses.getFullApiUrl() + 'create',params);
    }

    static async update(params, id) {
        return await Expenses.getAxiosInstance().post(Expenses.getFullApiUrl() + id,params);
    }

    static async getAll() {
        return await Expenses.getAxiosInstance().get(Expenses.getFullApiUrl() + "get/all");
    }

    static async delete(id) {
        return await Expenses.getAxiosInstance().delete(Expenses.getFullApiUrl() + id);
    }

    static async get(id) {
        return await Expenses.getAxiosInstance().get(Expenses.getFullApiUrl() + id);
    }

    static async approve(id) {
        return await Expenses.getAxiosInstance().post(Expenses.getFullApiUrl() + "expense/approve/" + id);
    }

    static async pegasusConnections(params) {
        return await Expenses.getAxiosInstance().post(Expenses.getFullApiUrl() + 'pegasus', params);
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/expenses/";
    }

    static getFullApiUrl(){
        let domain = location.pathname.split('/')[1]
        return BaseApi.getFullDomainApiUrl() + "api/" + domain + "/admin/expenses/";
    }
}